//import { connect } from 'react-redux'
import HomeTwoToneIcon from '@material-ui/icons/HomeTwoTone';
import Person from '@material-ui/icons/Person';
import HomePage from '../views/Home/HomePage';
import GridOn from '@material-ui/icons/GridOn';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MyProfile from '../views/User/MyProfile';
import { getFullUrl /*, MODO_ANONIMO*/ } from '../core/globals';
import ConsultaDinamicaWrapper from '../views/ConsultaDinamica/ConsultaDinamicaWrapper';

const defaultPath = 'mis-ocompras';

const routes = (parametros = {}) => {

  const consultasDinamicas = (() => {
    if(parametros?.OV_PROVEEDORES_CONSULTAS_DINAMICAS?.valor !== undefined) {
      try {
        return JSON.parse(parametros?.OV_PROVEEDORES_CONSULTAS_DINAMICAS?.valor);
      }
      catch(error) {
        console.log("Error al cargar consultas dinámicas");
      }
    } else return null;
  })();

  const staticRoutes = [
    {
      path: getFullUrl('inicio'),
      name: 'Inicio',
      component: HomePage,
      public: true,
      notShowOnMenu: true,
      icon: HomeTwoToneIcon,
    },
    {
      path: getFullUrl('my-profile'),
      name: 'Mi Perfil',
      component: MyProfile,
      public: true,
      private: false,
      notShowOnMenu: true,
      icon: Person,
    },
  ];

  let routeList = [];

  if(parametros?.OV_PROVEEDORES_RUTAS_PERFILES?.valor !== undefined) {
    try {
      const rutasPerfiles = JSON.parse(parametros?.OV_PROVEEDORES_RUTAS_PERFILES?.valor);
      for(const staticRoute of staticRoutes) {
        const perfilesKey = Object.keys(rutasPerfiles).find((configPerfilesKey) => {
          return staticRoute.path.indexOf(configPerfilesKey) >= 0;
        });
        const alreadyExists = routeList.find((r) => r.path === staticRoute.path);
        if(!alreadyExists) {
          if(perfilesKey !== undefined) {
            routeList.push({
              ...staticRoute,
              roles: rutasPerfiles[perfilesKey]
            });
          }
          else routeList.push(staticRoute);
        }
      }
    }
    catch(error) {
      console.log("Error al cargar los perfiles del usuario");
    }
  }

  routeList = routeList.length === 0 ? staticRoutes : routeList;

  if(consultasDinamicas) {
    consultasDinamicas.consultas.forEach((consulta, indice) => {
      if(consulta.collapse && Array.isArray(consulta.views)) {
        routeList.push({
          name: consulta.descripcion,
          path: "#",
          collapse: true,
          icon: MoreHorizIcon,
          private: true,
          disabled: !consulta.activa,
          notShowOnMenu: !consulta.mostrar,
          roles: consulta.roles,
          views: consulta.views.map((subruta, indice) => {
            return {
              path: getFullUrl(subruta.ruta),
              name: subruta.descripcion,
              component: ConsultaDinamicaWrapper,
              private: true,
              public: false,
              disabled: !subruta.activa,
              notShowOnMenu: !subruta.mostrar,
              icon: GridOn,
              consulta: subruta,
              roles: subruta.roles,
              index: indice
            };
          })
        });
      }

      routeList.push({
        path: getFullUrl(consulta.ruta),
        name: consulta.descripcion,
        component: ConsultaDinamicaWrapper,
        private: true,
        public: false,
        disabled: !consulta.activa,
        notShowOnMenu: !consulta.mostrar,
        roles: consulta.roles,
        icon: GridOn,
        consulta: consulta,
        index: indice
      });
    });
  }

  let defaultPathTo = getFullUrl(defaultPath);
  let defaultRoute = routeList.find((r) => r.path === defaultPathTo);

  if(!defaultRoute) {
    defaultPathTo = getFullUrl('inicio');
  }
  else if(defaultRoute?.index > -1) {
    defaultPathTo = {
      pathname: defaultRoute.path,
      state: {
        consulta: defaultRoute.index
      }
    };
  }

  routeList.push(
    {
      redirect: true,
      path: getFullUrl(),
      pathTo: defaultPathTo,
      name: 'Inicio',
    });

  return routeList;
};

export default routes;
